// components

import Header from "./components/Header";
import Nav from "./layout/Nav";
import About from "./pages/home/About";
import Banner from "./pages/home/Banner";
import Contact from "./pages/home/Contact";
import Projects from "./pages/home/Projects";


const App = () => {
  return (
    <div className="bg-site bg-no-repeat bg-cover overflow-hidden">
      <Header />
      <Nav />
      <Banner />
      <About />
      <Projects />
      <Contact />
    </div>
  );
};

export default App;
